/*global process*/
import { applyMiddleware, compose } from 'redux'
import ReduxThunk from 'redux-thunk'
import { routerMiddleware } from 'connected-react-router'
import { createLogger } from 'redux-logger'

export const assembleMiddleware = (history) => {
    const composeEnhancers =
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    const reduxLogs = createLogger()

    const middlewares = [ReduxThunk, routerMiddleware(history)]
    if (process.env.REACT_APP_REDUX_LOGGING) {
        middlewares.push(reduxLogs)
    }

    return composeEnhancers(applyMiddleware(...middlewares))
}

export default assembleMiddleware
